import { FC, useContext, useMemo } from 'react';
import { Breadcrumbs, Typography } from '@robocorp/components';

import { useCurrentOrFirstOrganization, useCurrentOrFirstWorkspace } from '~/queries';
import { BreadcrumbContext } from '~/hooks';
import NavLink from './NavLink';

const Breadcrumb: FC = () => {
  const { data: currentOrganization } = useCurrentOrFirstOrganization();
  const { data: currentWorkspace } = useCurrentOrFirstWorkspace();
  const [breadcrumbs] = useContext(BreadcrumbContext);

  const breadcrumbItems = useMemo(() => {
    let path = '/';

    if (currentOrganization?.short_name && currentWorkspace?.short_name) {
      path = `/${currentOrganization?.short_name}/${currentWorkspace?.short_name}`;
    } else if (currentOrganization?.short_name) {
      path = `/${currentOrganization?.short_name}`;
    }

    return breadcrumbs.map(({ hidden, text, urlPart }, idx) => {
      if (!urlPart) {
        // eslint-disable-next-line react/no-array-index-key
        return <Typography key={`${path}-${idx}`}>{text}</Typography>;
      }

      path = `${path}/${urlPart}`;

      if (hidden) {
        return null;
      }

      return (
        <NavLink key={urlPart} variant="subtle" fontWeight="medium" to={path}>
          {text}
        </NavLink>
      );
    });
  }, [currentOrganization?.short_name, currentWorkspace?.short_name, breadcrumbs]);

  return <Breadcrumbs>{breadcrumbItems}</Breadcrumbs>;
};

export default Breadcrumb;
